import _Vue from "vue";
import i18n from '../i18n'

export class Validation {
    public required(value: any, message: string): true | string {
        return !!value || message || i18n.t('validation.required').toString();
    }

    public decimal(value: number, message: string): true | string {
        return !isNaN(value) || message || i18n.t('validation.decimal').toString();
    }
    
    public percentage(value: number, message: string): true | string {
        return value <= 100 || message || i18n.t('validation.percentage').toString();
    }
    
    public confirmed(value: boolean, message: string): true | string {
        return value === true || message || i18n.t('validation.confirm').toString();
    }

    public mail(value: string, message: string): true | string {
        return /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-Z0-9-]+\.)+[A-Z]{2,6}$/i.test(value) || message || i18n.t('validation.mail').toString();
    }

    public listNotEmpty(value: [], message: string): true | string {
        return !!value && value.length > 0 || message || i18n.t('validation.listNotEmpty').toString();
    }
}

export const validation = new Validation();

export function ValidationPlugin(Vue: typeof _Vue): void {
    Vue.prototype.$validation = validation;
}

declare module 'vue/types/vue' {
    interface Vue {
        $validation: Validation;
    }
}

